import { Outlet, useLocation } from "react-router-dom";
import Navbar from "components/navigation/Navbar";
import Footer from "components/navigation/Footer";

const Layout = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <>
      {isHomePage ? (
        <Outlet />
      ) : (
        <>
          <Navbar />
          <main className="min-h-screen">
            <Outlet />
          </main>
          <Footer />
        </>
      )}
    </>
  );
};

export default Layout;
